import React from 'react';
import "./NotificationContainer.css";
import { Notification } from "./Notification.js";

/**
 * @description Container that displays a list of notifications
 * @param {any} props
 */
export function NotificationContainer(props) {

    /**
     * @description Renders a single Notification from a NotificationBuilder
     * @param { NotificationBuilder } notification
     */
    function renderNotification(notification) {
        return (
            <Notification key={notification.id} notification={notification} lifetime="5000" transitionDelay="600" />
        );
    }

    let notificationElements = [];

    props.notifications.forEach(notification => {
        let notificationElement = renderNotification(notification);

        notificationElements.push(notificationElement);
    });

    return (
        <div className="notification-container">
            {notificationElements}
        </div>
    );
}
